import { Tag } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import { TTrajectoryAction } from "@/types";
import { cn } from "@/utils/classes";

function ActionTags({
  className,
  reductionFactor,
  recommended,
  category,
  difficulty,
}: {
  className?: string;
  reductionFactor: TTrajectoryAction["reduction_factor"];
  recommended: TTrajectoryAction["recommended"];
  category: TTrajectoryAction["category"];
  difficulty: TTrajectoryAction["difficulty"];
}) {
  const { t } = useTranslation(["formatter", "trajectory", "categories"]);

  return (
    <div
      className={cn(
        "gap-2xs whitespace flex flex-wrap items-center",
        className
      )}
    >
      <Tag
        intent="secondary"
        text={t("formatter:percentage", {
          value: -reductionFactor,
          signDisplay: "exceptZero",
        })}
      />
      {recommended && (
        <Tag intent="secondary" text={t("trajectory:actionPlan.recommended")} />
      )}
      <Tag text={t(`categories:${category}`)} />
      <Tag text={t(`trajectory:actionPlan.difficulty.${difficulty}`)} />
    </div>
  );
}

export default ActionTags;
